import styled from "styled-components";

const LogButton = styled.button`
  border-radius: 5px;
  background-color: #00b9cd;
  color: whitesmoke;
  border: 1px solid #00b9cd;
  font-weight: bold;
  padding: 5px;
  font-size: 14px;
`;

export default LogButton;
